module.exports = __webpack_public_path__ + "img/Night At The Museum 2.af279344.jpeg";